import { EmployeeCell } from "components/cell/employee/cell";
import {
  ActiveJobsCell,
  ClientCell,
  DepartmentsCell,
  ProjectCell,
  ViewAmountCell,
  DedicatedBillingPercentageCell,
  FixedBillingPercentageCell,
  HourlyBillingPercentageCell,
  BucketBillingPercentageCell,
  RecurringBillingPercentageCell,
  AmountCell,
} from "./cells";

const baseColumns = {
  project: {
    id: "name",
    header: "Project",
    accessorKey: "name",
    cell: ProjectCell,
    sortable: true,
  },
  client: {
    id: "client",
    header: "Client",
    accessorKey: "client",
    sortable: true,
    cell: ({ row }) => {
      const { first_name, last_name } = row.original.client || {};
      return <div>{(first_name || "") + " " + (last_name || "")}</div>
    }
  },
  company: {
    id: "company",
    header: "Company",
    accessorKey: "client.company_id.name",
    sortable: true,
  },
  departments: {
    id: "departments",
    header: "Departments",
    cell: DepartmentsCell,
  },
  jobs_count: {
    id: "jobs_count",
    header: "No. of Jobs",
    accessorKey: "jobs",
    cell: ({ getValue }) => {
      const jobs = getValue() || [];
      return jobs.length;
    },
  },
  amount: {
    id: "total_amount",
    header: "Amount",
    accessorKey: "jobs",
    cell: ViewAmountCell,
    sortable: false,
  },
  sales_coordinator: {
    id: "sales_coordinator",
    header: "SC",
    accessorKey: "sales_coordinator",
    cell: EmployeeCell,
    sortable: true,
  },
  account_manager: {
    id: "account_manager",
    header: "AM",
    accessorKey: "account_manager",
    cell: EmployeeCell,
    sortable: true,
  },
  dedicated_billing_percentage: {
    id: "dedicated_billing_percentage",
    header: "% of Dedicated Billing",
    accessorKey: "jobs",
    cell: DedicatedBillingPercentageCell,
    sortable: false,
  },
  fixed_billing_percentage: {
    id: "fixed_billing_percentage",
    header: "% of Fixed Billing",
    accessorKey: "jobs",
    cell: FixedBillingPercentageCell,
    sortable: false,
  },
  hourly_billing_percentage: {
    id: "hourly_billing_percentage",
    header: "% of Hourly Billing",
    accessorKey: "jobs",
    cell: HourlyBillingPercentageCell,
    sortable: false,
  },
  bucket_billing_percentage: {
    id: "bucket_billing_percentage",
    header: "% of Bucket Billing",
    accessorKey: "jobs",
    cell: BucketBillingPercentageCell,
    sortable: false,
  },
  recurring_billing_percentage: {
    id: "recurring_billing_percentage",
    header: "% of Recurring Billing",
    accessorKey: "jobs",
    cell: RecurringBillingPercentageCell,
    sortable: false,
  },
};

export const getColumnsByType = (type) => {
  const baseColumnKeys = [
    "project",
    "client",
    "company",
    "departments",
    "jobs_count",
    "amount",
    "sales_coordinator",
    "account_manager",
  ];

  // Jobs count with type filter
  const jobsCountCell = ({ getValue }) => {
    const jobs = getValue() || [];
    return type ? jobs.filter((j) => j.type === type).length : jobs.length;
  };

  // Amount with type filter
  const filteredAmountCell = ({ getValue }) => {
    const jobs = getValue() || [];

    const filteredJobs = type ? jobs.filter((j) => j.type === type) : jobs;

    return <AmountCell jobs={filteredJobs} />;
  };

  // Pick billing column
  let billingPercentageColumn;
  switch (type) {
    case "dedicated":
      billingPercentageColumn = "dedicated_billing_percentage";
      break;
    case "fixed":
      billingPercentageColumn = "fixed_billing_percentage";
      break;
    case "hourly":
      billingPercentageColumn = "hourly_billing_percentage";
      break;
    case "bucket":
      billingPercentageColumn = "bucket_billing_percentage";
      break;
    case "recurring":
      billingPercentageColumn = "recurring_billing_percentage";
      break;
    default:
      billingPercentageColumn = null;
      break;
  }

  const columnKeys = billingPercentageColumn
    ? [...baseColumnKeys, billingPercentageColumn]
    : baseColumnKeys;

  return columnKeys.map((key) => {
    if (key === "jobs_count")
      return { ...baseColumns[key], cell: jobsCountCell };
    if (key === "amount")
      return { ...baseColumns[key], cell: filteredAmountCell };
    return baseColumns[key];
  });
};
